// Temas compartilhados — Conformidade LP Vidal (Inter, border-radius 12px)
// Fonte única usada pelo App principal e por páginas standalone (ex.: /pagamento-teste).

export const lightTheme = {
  bar: "rgba(28, 28, 30, 0.95)",
  primary: "#10b981",
  primaryDark: "#059669",
  primaryLight: "#34d399",
  secondary: "#03dac6",
  tertiary: "#4835efff",
  header: "#1c1c1e",
  body: "#fafbfc",
  text: "rgba(0, 0, 0, 0.85)",
  textSecondary: "rgba(0, 0, 0, 0.5)",
  border: "rgba(0, 0, 0, 0.06)",
  border2: "rgba(0, 0, 0, 0.10)",
  border3: "rgba(0, 0, 0, 0.03)",
  card: "rgba(255, 255, 255, 0.98)",
  card2: "rgba(248, 250, 252, 0.95)",
  cardBg: "rgba(255, 255, 255, 0.98)",
  cardBg2: "rgba(255, 255, 255, 0.95)",
  tableRow: "rgba(255, 255, 255, 0.9)",
  tableRowHover: "rgba(255, 255, 255, 1)",
  buttonBg: "rgba(255, 255, 255, 0.95)",
  buttonHover: "rgba(0, 0, 0, 0.03)",
  contrast: "rgba(0, 0, 0, 0.02)",
  contrast2: "rgba(0, 0, 0, 0.04)",
  radius: "12px",
  radiusSm: "8px",
  radiusLg: "16px",
  shadow: "0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02)",
  shadowMd: "0 4px 12px rgba(0,0,0,0.06)",
  success: "#10b981",
  error: "#ef4444",
  warning: "#f59e0b",
  info: "#3b82f6",
};

export const darkTheme = {
  bar: "rgba(13, 15, 20, 0.95)",
  primary: "#10b981",
  primaryDark: "#059669",
  primaryLight: "#34d399",
  secondary: "rgba(255, 255, 255, 0.05)",
  tertiary: "#4835efff",
  header: "#0d0f14",
  body: "#0d0f14",
  text: "#e5e7eb",
  textSecondary: "rgba(255, 255, 255, 0.45)",
  border: "rgba(255, 255, 255, 0.06)",
  border2: "rgba(255, 255, 255, 0.08)",
  border3: "rgba(255, 255, 255, 0.03)",
  card: "rgba(18, 20, 26, 0.95)",
  card2: "rgba(24, 27, 34, 0.9)",
  cardBg: "rgba(18, 20, 26, 0.98)",
  cardBg2: "rgba(24, 27, 34, 0.95)",
  tableRow: "rgba(18, 21, 26, 0.9)",
  tableRowHover: "rgba(30, 33, 42, 1)",
  buttonBg: "rgba(24, 27, 34, 0.95)",
  buttonHover: "rgba(36, 40, 50, 0.5)",
  contrast: "rgba(255, 255, 255, 0.02)",
  contrast2: "rgba(255, 255, 255, 0.04)",
  load: "rgba(0, 0, 0, .3)",
  load2: "rgba(0, 0, 0, .5)",
  radius: "12px",
  radiusSm: "8px",
  radiusLg: "16px",
  shadow: "0 1px 3px rgba(0,0,0,0.2), 0 1px 2px rgba(0,0,0,0.12)",
  shadowMd: "0 4px 12px rgba(0,0,0,0.3)",
  success: "#10b981",
  error: "#ef4444",
  warning: "#f59e0b",
  info: "#3b82f6",
};
